import React from 'react'

function CertificateSample({ title = "Sample Certificate", imagePath = "/assets/services/1/membership-certificate.jpg", imageContainerClass = "", imageClass = "", imageContainerRadiusClass = "", imageRadiusClass = "", isApplyGradient = true }) {
    return (
        <section className={`w-full${isApplyGradient ? ' bg-gradient-radial' : ''} py-2 lg:py-12`}>
            <div className="container mx-auto px-4 lg:px-13">
                <div className='w-full flex flex-col items-center gap-6 mb-4'>
                    <h2
                        className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                        {title}
                    </h2>
                </div>
                <div className="flex flex-row flex-wrap justify-center items-start gap-6 p-4 mx-auto">
                    <div className={`w-[25rem] lg:w-[30rem] ${imageContainerRadiusClass || 'rounded-xl'} shadow-[0px_0px_7px_4px_rgba(171,198,248,0.5)] bg-white overflow-hidden p-2 ${imageContainerClass} ${imageRadiusClass || 'rounded-[2.5rem]'} `}>
                        <img className={`w-full h-full object-cover ${imageClass}`} src={imagePath} alt="membership-card" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CertificateSample